import { Alert, Drawer, DrawerBody, DrawerHeader, Link, Typography, } from '@one-thd/sui-atomic-components';
import React from 'react';
import { Store, QRCode as QRCodeIcon, BuyAgain } from '@one-thd/sui-icons';
import QRCode from '../QR/QRCode';
import '../../../styles/returns.scss';
var SorisQrDrawer = function (_a) {
    var displaySorisDrawer = _a.displaySorisDrawer, closeDrawer = _a.closeDrawer, qrCodeImg = _a.qrCodeImg, _b = _a.sorisId, sorisId = _b === void 0 ? '' : _b, sorisQrApiError = _a.sorisQrApiError;
    var imageSrc = "data:image/png;base64,".concat(qrCodeImg);
    var ErrorMessage = function () { return (React.createElement(React.Fragment, null,
        React.createElement(Alert, { status: "error" },
            React.createElement(Typography, { variant: "body-base" }, "Looks like we had a technical issue. We couldn't generate your QR code. But you can still provide the Return ID listed below to the store associate to process your return.")),
        React.createElement("div", { className: "sui-flex sui-justify-center sui-m-auto sui-mb-4" },
            React.createElement(Typography, { variant: "body-xs", weight: "bold" },
                "Return ID: ",
                sorisId)))); };
    return (React.createElement(Drawer, { onClick: function (event) {
            event.stopPropagation();
        }, open: displaySorisDrawer, onClose: closeDrawer, position: "right", className: "drawer-z-index-fix" },
        React.createElement(DrawerHeader, { title: "In-Store Return QR Code", onClose: closeDrawer }),
        React.createElement(DrawerBody, null,
            sorisQrApiError ? (React.createElement(ErrorMessage, null)) : (React.createElement(QRCode, { imageSrc: imageSrc, sorisId: sorisId })),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-5" },
                React.createElement("div", { className: "sui-flex" },
                    React.createElement("div", { className: "soris-drawer-icon" },
                        React.createElement(Store, null)),
                    React.createElement(Typography, { variant: "body-base" },
                        "Take your return item(s) to any",
                        ' ',
                        React.createElement(Link, { variant: "body-base", href: "https://www.homedepot.com/l/", target: "_blank" }, "Home Depot store"),
                        ".")),
                React.createElement("div", { className: "sui-flex" },
                    React.createElement("div", { className: "soris-drawer-icon" },
                        React.createElement(QRCodeIcon, null)),
                    React.createElement(Typography, { variant: "body-base" }, "Present your return QR code to the associate at the returns counter.")),
                React.createElement("div", { className: "sui-flex" },
                    React.createElement("div", { className: "soris-drawer-icon" },
                        React.createElement(BuyAgain, null)),
                    React.createElement(Typography, { variant: "body-base" }, "It may take up to 10 business days for your bank to put the funds back into your account."))))));
};
export default SorisQrDrawer;
